import { useTranslation } from 'react-i18next';

import classes from './WeeklyForm.module.scss';
import React, { useEffect } from 'react';
import { defaultCronObject, Props } from '../CrontabView';
import { Dropdown } from 'primereact/dropdown';
import { Calendar, CalendarProps } from 'primereact/calendar';
import moment from 'moment';

const WeeklyForm = ({ onCronChanged, date, day = 1 }: Props) => {

  const { t: translate } = useTranslation();

  useEffect(() => {
    onCronChanged({
      ...defaultCronObject,
      minutes: date.getMinutes().toString(),
      hours: date.getHours().toString(),
      dayWeek: day.toString()
    });
  }, []);

  const onDayChangeHandler = (value: string) => {
    const index = moment.weekdays().findIndex(d => d === value);
    onCronChanged({
      ...defaultCronObject,
      dayWeek: index.toString(),
      minutes: date.getMinutes().toString(),
      hours: date.getHours().toString(),
    });
  };

  const onHourChangedHandler = (dropdownHour:CalendarProps) => {
    const tmpDate = (dropdownHour.value as Date);
    onCronChanged({
      ...defaultCronObject,
      dayWeek: day.toString(),
      minutes: tmpDate.getMinutes().toString(),
      hours: tmpDate.getHours().toString(),
    });
  };

  return (
    <>
      <div className={ classes['form-control'] }>
        <label>{ translate('cron-tab.input.on') }</label>
        <Dropdown
          value={ moment.weekdays()[day] }
          options={ moment.weekdays() }
          onChange={ (e) => onDayChangeHandler(e.value) }
          placeholder={ translate('cron-tab.input.select_day') }
          scrollHeight="350px"
        />
      </div>
      <div className={ classes['form-control'] }>
        <label>{ translate('cron-tab.input.at') }</label>
        <Calendar
          showIcon
          showTime
          timeOnly
          hourFormat="24"
          value={ date }
          icon={ 'pi pi-clock' }
          onChange={ onHourChangedHandler }
        />
      </div>
    </>
  );
};

export default WeeklyForm;